'use es6';

import { combineReducers } from 'redux';
import Immutable from 'immutable';
import * as RequestState from 'ecosystem-marketplace-core/constants/RequestState';
import FeaturedCalloutListing from 'ecosystem-marketplace-core/records/FeaturedCalloutListing';
import * as ActionTypes from '../actions/ActionTypes';

const requestState = (state = RequestState.UNINITIALIZED, action) => {
  switch (action.type) {
    case ActionTypes.FEATURED_CALLOUTS_REQUESTED:
      return RequestState.PENDING;

    case ActionTypes.FEATURED_CALLOUTS_RECEIVED:
      return RequestState.SUCCEEDED;

    case ActionTypes.FEATURED_CALLOUTS_FAILED:
      return RequestState.FAILED;

    default:
      return state;
  }
};

const listings = (state = Immutable.List(), action) => {
  switch (action.type) {
    case ActionTypes.FEATURED_CALLOUTS_RECEIVED:
      {
        return Immutable.List(action.payload.map(listing => FeaturedCalloutListing.from(listing)));
      }

    default:
      return state;
  }
};

export default combineReducers({
  requestState,
  listings
});